/** "Klara Kundin" from a user record (empty when unknown). */
export const fullNameOf = user =>
  [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim();
